/**
 * Signup-confirmation links from the email carry `?confirm=1&token_hash=…&type=email`.
 * `verifyOtp` does not need the PKCE verifier, so the link works in whichever browser opens it.
 * `type=recovery` is deliberately NOT handled here: ResetPasswordView owns that exchange.
 */
interface VerifyOtpAuth {
    verifyOtp?: (params: { token_hash: string; type: 'email' }) => Promise<{ data: { session: unknown }; error: unknown }>;
}

export function hasEmailConfirmLink(params: URLSearchParams): boolean {
    return Boolean(params.get('token_hash')) && params.get('type') === 'email';
}

/** Returns null when the URL is not a confirmation link. Strips the URL first so a reload cannot replay it. */
export async function redeemEmailConfirmLink(
    auth: VerifyOtpAuth,
    params: URLSearchParams,
): Promise<{ data: { session: unknown }; error: unknown } | null> {
    const tokenHash = params.get('token_hash');
    if (!tokenHash || params.get('type') !== 'email' || typeof auth.verifyOtp !== 'function') return null;
    window.history.replaceState({}, document.title, window.location.pathname);
    return auth.verifyOtp({ token_hash: tokenHash, type: 'email' });
}
